import { defineMessages, type MessageDescriptor } from 'react-intl';

export const messages: {
	ctaTitle: MessageDescriptor;
	ctaDescription: MessageDescriptor;
	ctaLink: MessageDescriptor;
	whyAmISeeingThisReason: MessageDescriptor;
} = defineMessages({
	ctaTitle: {
		id: 'jira-twg-cli-cta.cta-title',
		defaultMessage: 'Bring Jira context into your terminal',
		description: 'CTA title for the Jira TWG CLI CTA',
	},
	ctaDescription: {
		id: 'jira-twg-cli-cta.cta-description',
		defaultMessage:
			'Give your agents better Jira context while using fewer credits. Query open issues and pull tasks from epics with Teamwork Graph CLI.',
		description: 'CTA description for the Jira TWG CLI CTA',
	},
	ctaLink: {
		id: 'jira-twg-cli-cta.cta-link',
		defaultMessage: 'Install the CLI',
		description: 'CTA link text for the Jira TWG CLI CTA',
	},
	whyAmISeeingThisReason: {
		id: 'jira-twg-cli-cta.why-am-i-seeing-this-reason',
		defaultMessage: 'You have indicated interest in using coding agents',
		description: 'Reason for why the user is seeing the Jira TWG CLI CTA',
	},
});
